module.exports = __webpack_public_path__ + "img/k-fix-icon.c86c818c.png";